import { render } from "./ListCharacters.vue?vue&type=template&id=5519b46a"
import script from "./ListCharacters.vue?vue&type=script&lang=js"
export * from "./ListCharacters.vue?vue&type=script&lang=js"

import "./ListCharacters.vue?vue&type=style&index=0&id=5519b46a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__